import axiosInstance from "../../lib/axiosInstance";

// Developer registry (bearer-authed). registerDeveloper is idempotent — safe to
// call on every "Join as developer" return.
export const registerDeveloper = async () => {
  const response = await axiosInstance.post("/developers/register");
  return response?.data?.developer;
};

export const getDeveloperMe = async () => {
  const response = await axiosInstance.get("/developers/me");
  return response?.data?.developer;
};
